import { FastshiftTicketStatus } from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

import { DropdownItem } from '@atlaskit/dropdown-menu';
import Lozenge from '@atlaskit/lozenge';

import { getTicketStatusColor } from '@/common/utils/ticket-status';

import { FilterOption } from '../../../types';

export const StatusFilterDropdownItem = ({
	option,
	isSelected,
	onStatusChange,
	sendStatusFilterDropdownItemClickUIEvent,
}: {
	option: FilterOption<FastshiftTicketStatus>;
	isSelected: boolean;
	onStatusChange: (option: FilterOption<FastshiftTicketStatus>) => void;
	sendStatusFilterDropdownItemClickUIEvent: (selectedStatus: string) => void;
}) => {
	return (
		<DropdownItem
			key={option.value}
			onClick={() => {
				sendStatusFilterDropdownItemClickUIEvent(option.value);
				onStatusChange(option);
			}}
			isSelected={isSelected}
		>
			<Lozenge appearance={getTicketStatusColor(option.value)}>{option.label}</Lozenge>
		</DropdownItem>
	);
};
